import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PaymentType } from '@spartacus/cart/base/root';
import { CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root';
import { QueryState } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, tap, withLatestFrom } from 'rxjs/operators';

import { DpGtmService } from '@app/core/services/gtm.service';

import { DpCheckoutService } from '../../services';

@Component({
    selector: 'dp-payment-type',
    templateUrl: './payment-type.component.html',
    styleUrls: ['./payment-type.component.scss'],
    standalone: false
})
export class DpPaymentTypeComponent implements OnDestroy {
  typeSelected = '';
  paymentTypes$: Observable<PaymentType[]>;

  typeSelected$: Observable<QueryState<PaymentType | undefined>>;
  loading$: Observable<boolean>;

  constructor(
    private readonly checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    private readonly activatedRoute: ActivatedRoute,
    private readonly dpGtmService: DpGtmService,
    private readonly dpCheckoutService: DpCheckoutService
  ) {
    this.dpCheckoutService.setActivatedRoute(this.activatedRoute);
    this.loading$ = this.dpCheckoutService.processing$.asObservable();
    this.paymentTypes$ = this.checkoutPaymentTypeFacade.getPaymentTypes();

    this.typeSelected$ = this.checkoutPaymentTypeFacade.getSelectedPaymentTypeState().pipe(
      withLatestFrom(this.checkoutPaymentTypeFacade.getPaymentTypes()),
      tap(([selected, paymentTypes]) => {
        // for the new users getSelectedPaymentType() returns hardcoded CARD by default,
        // therefore we won't have any selected payment type if we don't support CARD
        const result = paymentTypes?.find((type) => type.code === selected.toString());

        if (result && typeof result === 'string') {
          this.typeSelected = result;
        } else {
          this.typeSelected = paymentTypes[0]?.code || 'INVOICE'; // Assign a default value
        }
      }),
      map(([selected]) => selected ?? '')
    ) as Observable<QueryState<PaymentType | undefined>>;
  }

  changeType(code: string): void {
    this.dpCheckoutService.setPaymentType(code);
    this.typeSelected = code;
  }

  ngOnDestroy(): void {
    this.dpGtmService.pushCheckoutTagV2('add_payment_info', {
      payment_type: this.typeSelected
    });
  }
}
